module.exports = __webpack_public_path__ + "static/media/flagicon.1b3a5332.svg";